'use client';

import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { logger } from '@/Util/globals';
import Link from 'next/link';

export default function ErrorComponent({
  error,
  reset
}: {
  readonly error: Error & { digest?: string };
  readonly reset: () => void;
}) {
  useEffect(() => {
    logger('error')(error);
  }, [error]);

  return (
    <div className="px-5 py-5">
      <h2>There was an error during loading the page...</h2>
      <Button color="primary" aria-label="reload page" className="mb-xs-3" onClick={() => reset()}>
        Please try again
      </Button>
      <div>
        <Link href="/">or go back to Home</Link>
      </div>
    </div>
  );
}
